<script>
  export let entries = [];
</script>
{#if entries.length}
<div class="protocol-debug">
  <ul>
    {#each entries as entry}
      <li>{entry}</li>
    {/each}
  </ul>
</div>
{/if}
